import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';
import { horizontalScrollTabs } from '@alfa-bank/site-helpers-common/scroll/horizontal-scroll-tabs';

export const useFirstHorizontalScroll = (wrapperRef: RefObject<HTMLDivElement>) => {
    const selectedTabRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (selectedTabRef.current) {
            horizontalScrollTabs(wrapperRef)({
                currentTarget: selectedTabRef.current,
            });
        }
    }, [wrapperRef]);

    return selectedTabRef;
};
